import {useEffect} from 'react'
import {useAuth, useUser} from "@clerk/clerk-react";
import {getCookies} from './cookies.tsx'

const env = import.meta.env.VITE_APP_ENV;

// NOTE: In prod, clerk uses cookies -- cookies which we can't read from Javascript (directly) so
// we have to hack around that. In dev, clerk uses local browser storage, which we can read from easily.
//
// NB: Clerk doesn't have a staging equivalent. They only have dev and prod. This puts us in an awkward
// position since we have to choose one for our staging. We've chosen prod so that we can ensure compatibility
// before it rolls out to real prod.
const usesCookies = env == "prod" || env == "staging" || env == "eu-prod" || env == "eu-staging";

const cliCallbackUrl = 'http://localhost:3535/done?p=';

function AppSignedIn() {
    const {isLoaded, isSignedIn, userId, sessionId} = useAuth();
    const {isLoaded: isUserLoaded, isSignedIn: isUserSignedIn, user} = useUser();
    const ready = isLoaded && isSignedIn && isUserLoaded && isUserSignedIn;

    // Runs once Clerk has loaded the signed-in user, then hands the session to the CLI.
    useEffect(() => {
        if (!ready) return;

        let cancelled = false;
        let timeout: ReturnType<typeof setTimeout> | undefined;

        const redirect = (credentials: {cookies: Record<string, string>} | {token: string}) => {
            if (cancelled) return;
            const value = btoa(JSON.stringify({userId, sessionId, ...credentials, user}));
            timeout = setTimeout(() => window.location.replace(cliCallbackUrl + value), 1000);
        };

        if (usesCookies) {
            getCookies().then(cookies => redirect({cookies})).catch(error => console.error(error));
        } else {
            redirect({token: localStorage["clerk-db-jwt"]});
        }

        return () => {
            cancelled = true;
            clearTimeout(timeout);
        };
    }, [ready]);

    return <p className="text-doto">Redirecting...</p>
}

export default AppSignedIn;
